import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Doughnut } from 'react-chartjs-2';
import InputLabel from '@material-ui/core/InputLabel';

import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import { makeStyles } from '@material-ui/styles';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_property_overview, get_showrooms } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportPropertyOverview extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];

        this.ref = React.createRef();
        this.state = {
            csv_output: [],
            start_print: false,
            redraw: false,
            chartData: {},
            doughnuts: [],
            showrooms: [],
            bar_options: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 5,
                            stepSize: 1
                        }
                    }]
                }

            },
            values: {
                property: "",
                appointment_type: "all",
                date_from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                date_to: moment().format("yyyy-MM-DD"),
            },
            rawReport: { agencies: [] },
        };
        this.get_data();
        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms,
                values: {
                    ...this.state.values,
                }
            }, () => {
                this.get_data();
            });
        }
    }

    parse_chart_data(data) {
        var new_bar_options = {


        };
        var max_y_tick = 0;

        var labels = [];
        var doughnuts = [];
        var datasets = [{
            label: 'Appointment: No Show',
            stack: "stack1",
            backgroundColor: '#bdbdbd',
            borderColor: '#bdbdbd',
            borderWidth: 1,
            hoverBackgroundColor: '#bdbdbd',
            hoverBorderColor: '#bdbdbd',
            data: []
        }, {
            label: 'Appointment:  Arrived',
            stack: "stack1",
            backgroundColor: '#66bb6a',
            borderColor: '#66bb6a',
            borderWidth: 1,
            hoverBackgroundColor: '#66bb6a',
            hoverBorderColor: '#66bb6a',
            data: []
        }, {
            label: 'Appointment: Booked',
            stack: "stack1",
            backgroundColor: '#42a5f5',
            borderColor: '#42a5f5',
            borderWidth: 1,
            hoverBackgroundColor: '#42a5f5',
            hoverBorderColor: '#42a5f5',
            data: []
        },
        {
            label: 'Guests: No Show',
            stack: "stack2",
            backgroundColor: 'rgba(189, 189, 189, 0.56)',
            borderColor: 'rgba(189, 189, 189, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(189, 189, 189, 0.56)',
            hoverBorderColor: 'rgba(189, 189, 189, 0.56)',
            data: []
        },
        {
            label: 'Guests: Arrived',
            stack: "stack2",
            backgroundColor: 'rgba(102, 187, 106, 0.56)',
            borderColor: 'rgba(102, 187, 106, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(102, 187, 106, 0.56)',
            hoverBorderColor: 'rgba(102, 187, 106, 0.56)',
            data: []
        },
        {
            label: 'Guests: Booked',
            stack: "stack2",
            backgroundColor: 'rgba(66, 165, 245, 0.56)',
            borderColor: 'rgba(66, 165, 245, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(66, 165, 245, 0.56)',
            hoverBorderColor: 'rgba(66, 165, 245, 0.56)',
            data: []
        }
        ];
        if (data[0]) {
            for (var i = 0; i < data[0].agencies.length; i++) {
                var data_row = data[0].agencies[i];
                labels.push(data_row.name);

                datasets[0].data.push(data_row.total.no_show);
                datasets[1].data.push(data_row.total.arrived);
                datasets[2].data.push(data_row.total.total - data_row.total.no_show - data_row.total.arrived);
                datasets[3].data.push(data_row.total.no_show_pax);
                datasets[4].data.push(data_row.total.arrived_pax);
                datasets[5].data.push(data_row.total.total_pax - data_row.total.no_show_pax - data_row.total.arrived_pax);
                max_y_tick = max_y_tick > parseInt(data_row.total.total_pax) ? max_y_tick : parseInt(data_row.total.total_pax);
            }

            this.setState({
                ...this.state,
                chartData: {
                    labels: labels,
                    datasets: datasets
                },
                rawReport: data[0],
                bar_options: {
                    ...new_bar_options,
                    scales: {
                        yAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Value'
                            },
                            ticks: {
                                min: 0,
                                max: max_y_tick + 5,
                                stepSize: 1
                            }
                        }]
                    }
                }

            }, () => {
                this.downloadCSV();
            });
        }

    }
    handleChangeDate(date, name) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [name]: date
            }
        }, () => {
            this.get_data();
        });
    }
    async get_data() {
        var property = this.state.values.property;


        var data = await get_property_overview({
            ...this.state.values,
            property: property,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD")
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }

    downloadCSV() {
        var export_data = [];
        var header = ['', 'Appt. Arrived', 'Appt. No Show', "Appt. Booked", "Appt. Total", "Guest Arrived", "Guest No Show", "Guest Booked", "Guest Total"];

        export_data.push(header);

        this.state.rawReport.agencies.map((row) => {

            export_data.push([
                row.name,
                row.total.arrived,
                row.total.no_show,
                row.total.total - row.total.arrived - row.total.no_show,
                row.total.total,
                row.total.arrived_pax,
                row.total.no_show_pax,
                row.total.total_pax - row.total.arrived_pax - row.total.no_show_pax,
                row.total.total_pax
            ]);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );
    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Property_By_Agencies_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Property_By_Agencies_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Property by Agencies"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter"
                                >
                                    <div className="filter_field_wrapper">
                                        <InputLabel shrink id="metric_label">
                                            Property
                                        </InputLabel>
                                        <Select
                                            className="full_width"
                                            label="Property"
                                            onChange={this.handleChange.bind(this)}
                                            name="property"
                                            value={this.state.values.property}
                                        >

                                            {
                                                this.state.showrooms.map((showroom) => (
                                                    <MenuItem key={showroom.property_id}
                                                        value={showroom.property_id}>
                                                        {showroom.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            className="full_width"
                                            name="date_from"
                                            label="From"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_to"
                                            label="to"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>

                                </div>
                                <div
                                    style={{
                                        width: this.state.start_print ? 900 : "auto"
                                    }}
                                    ref={this.ref}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Property by Agencies</h1>
                                                </Grid>
                                            </Grid>


                                        </div>
                                    )}
                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '20vh'
                                    }}>
                                        <Bar
                                            redraw={this.state.redraw}
                                            width={this.state.start_print ? 900 : 'auto'}
                                            options={{
                                                ...this.state.bar_options,
                                                maintainAspectRatio: false,
                                                devicePixelRatio: 2
                                            }}
                                            data={this.state.chartData}></Bar>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    {this.state.rawReport && (
                                        <React.Fragment>
                                            <Table className="report_table hide_mobile">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                            colSpan={4}>Appointments</TableCell>
                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={4}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Arrived</TableCell>
                                                        <TableCell>No Show</TableCell>
                                                        <TableCell>Booked</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Arrived</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >No Show</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Booked</TableCell>
                                                        <TableCell
                                                            className="bold section_2"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.agencies.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{(row.name)}</TableCell>
                                                            <TableCell>{row.total.arrived}</TableCell>
                                                            <TableCell>{row.total.no_show}</TableCell>
                                                            <TableCell>{row.total.total - row.total.arrived - row.total.no_show}</TableCell>
                                                            <TableCell className="bold">{row.total.total}</TableCell>
                                                            <TableCell className="section_2">{row.total.arrived_pax}</TableCell>
                                                            <TableCell className="section_2">{row.total.no_show_pax}</TableCell>
                                                            <TableCell className="section_2">{row.total.total_pax - row.total.arrived_pax - row.total.no_show_pax}</TableCell>
                                                            <TableCell className="section_2 bold">{row.total.total_pax}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                            <Table className="report_table hide_desktop">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                            colSpan={4}>Appointments</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Arrived</TableCell>
                                                        <TableCell>No Show</TableCell>
                                                        <TableCell>Booked</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>


                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.agencies.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.name}</TableCell>
                                                            <TableCell>{row.total.arrived}</TableCell>
                                                            <TableCell>{row.total.no_show}</TableCell>
                                                            <TableCell>{row.total.total - row.total.arrived - row.total.no_show}</TableCell>
                                                            <TableCell className="bold">{row.total.total}</TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                            <Table className="report_table hide_desktop">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>

                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={4}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>

                                                        <TableCell
                                                            className="section_2"
                                                        >Arrived</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >No Show</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Booked</TableCell>
                                                        <TableCell
                                                            className="bold section_2"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.agencies.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.name}</TableCell>

                                                            <TableCell className="section_2">{row.total.arrived_pax}</TableCell>
                                                            <TableCell className="section_2">{row.total.no_show_pax}</TableCell>
                                                            <TableCell className="section_2">{row.total.total_pax - row.total.arrived_pax - row.total.no_show_pax}</TableCell>
                                                            <TableCell className="section_2 bold">{row.total.total_pax}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </React.Fragment>
                                    )}
                                </div>
                                <br></br>
                                <br></br>


                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
